import { gql } from '@apollo/client';

export default gql`
  mutation RemoveAllStudentsFromCourseMutation($courseId: String!) {
    student(courseId: $courseId)
      @rest(
        type: "Student"
        path: "courses/{args.courseId}/students/deleteAll"
        method: "DELETE"
      ) {
      _id
    }
  }
`;
